/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable sort-keys */
import {Sandbox} from '@exc/core';

export default {
  appId: 'experiencePlatformUI',
  distributionList: [`Grp-platform-ui@adobe.com`],
  name: 'platform',
  path: '/platform',
  serviceCode: 'acp',
  type: 'platform',
  dashboard: true,
  sandbox: {
    history: Sandbox.HISTORY_TYPES.HISTORY,
    sources:
      {
        dev: 'https://localhost.dev.cloud.adobe.io',
        qa: 'https://platform-int.adobe.com',
        stage: 'https://platform-stage.adobe.com',
        prod: 'https://platform.adobe.com'
      }
  },
  access: ['acp']
};
